import React from 'react';
import QuizBuilder from "./flow";
import { useQuizz } from "../../../application/quizz/hooks/useQuizz";
import ToolbarComponent from '../../ui/section';
import NavigationService from '../../../utils/history';

const QuizBuilderPage = (props) => {
    const { createQuizz } = useQuizz(props);
    const goBack = () => NavigationService.navigateBack();
    
    const create = async (data) => {
        await createQuizz(data);
        goBack();
    };
    return (
        <QuizBuilder onSubmit={(data) => create(data)} goBack={goBack} />
    )
}

export default QuizBuilderPage;